module.exports = __webpack_public_path__ + "img/bg1.1be7d897.jpg";